import { NgModule } from '@angular/core';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'app/components/shared/shared.module';
import { IfOnDomModule } from 'app/directives/if-on-dom.module';
import { LegfiCurrencyPipeModule } from 'app/pipes/format/legfi-currency.module';
import { CollectionProgressGraphComponent } from './collection-progress-graph.component';
import { OrganizationService } from 'app/services/organization/organization.service';
import { DomHelperService } from 'app/services/dom-helper.service';
import { LegfiCurrencyPipe } from 'app/pipes/format/legfi-currency.pipe';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { NgChartsModule } from 'ng2-charts';

@NgModule({
    imports: [
        SharedModule,
        NgbModule,
        IfOnDomModule,
        LegfiCurrencyPipeModule,
        MatSelectModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        NgChartsModule,
    ],
    exports: [
        CollectionProgressGraphComponent,
    ],
    declarations: [CollectionProgressGraphComponent],
    providers: [
        OrganizationService,
        DomHelperService,
        LegfiCurrencyPipe,
    ],
})
export class CollectionProgressGraphModule
{
}
